export const getDynamicFontSize = (text: string, maxWidth: number, baseFontSize: number): number => {
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    if (!context) return baseFontSize;
    context.font = `${baseFontSize}px Arial`;
    const textWidth = context.measureText(text).width;
    if (textWidth > maxWidth) {
        return (baseFontSize * maxWidth) / textWidth;
    }
    return baseFontSize;
};